import React, { FC, useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Route, Switch } from "react-router-dom";
import { ProductsMenuContext } from "../../index";
import OrganizationProductPackageIndexPage from "./pages/Index";

const OrganizationProductPackagePage: FC<RouteComponentProps> = (props) => {
	const { setMenuState } = useContext(ProductsMenuContext);
	useEffect(() => {
		setMenuState("packages");
	}, []);

	return (
		<Switch>
			<Route path={props.match.url + "/"} exact component={OrganizationProductPackageIndexPage} />
		</Switch>
	);
};
export default OrganizationProductPackagePage;
